import React, {useCallback, useContext, useRef, useState} from "react";
import {RealmContext, TreeContext} from "../../Store";
import DataobjectService from "../../../services/DataobjectService";
import MaterialTable, { MTableToolbar } from "@material-table/core";

import ComponentTypeAutoComplete from "../../../shared/ComponentTypeAutoComplete";
import {trackPromise} from "react-promise-tracker";
import DataComponentService from "../../../services/DataComponentService";
import FilterListIcon from '@mui/icons-material/FilterList';
import AddIcon from '@mui/icons-material/Add';

import ComponentFormView from "../Dataobjects/ComponentFormView";
import Button from "@mui/material/Button";
import Paper from "@mui/material/Paper";

import { header } from'../../../shared/headerStyle';
import UserService from "../../../services/UserService";

import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";


function DatacomponentTableView({dataComponents, setDatacomponents, realm, token, dataObjects, administrativeObjects}) {

    const [dataObjectSelected, setDataObjectSelected] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    const [componentType, setComponentType] = useState(null);
    const [componentSelected, setComponentSelected] = useState([]);
    const [attributeList, setAttributeList] = useState([]);
    const [componentTypeAttributes, setComponentTypeAttributes] = useState([]);

    const [DataComponentFormDialogOpen, setDataComponentFormDialogOpen] = useState(false);

    const [filtering, setFiltering] = useState(false);
    let hideDeactivatedColumn = true;

    const tableRef = useRef();

    const [realestateobjectGuid, setRealestateobjectGuid] = useState('');
    const tree = useContext(TreeContext);
    const treeItemsState = tree.items;


    const handleEditClick = async (event, rowData) => {
        event.preventDefault();
        setDataObjectSelected([]);
        setComponentSelected([]);
        let code = rowData.componentType?.mmsCode ? rowData.componentType?.mmsCode : rowData.componentTypeCode;
        if(code) {
            await trackPromise(
                (async () => {
                    const res = await DataComponentService.getComponentByGuid(token, realm, rowData.guid);
                    setRealestateobjectGuid(res.data?.realestateobjectGuid);
                    const result = await DataComponentService.getComponentTypeByCode(token, realm, code);
                    if(result && result.data && result.data.length > 0 && result.data[0].attribute) {
                        const componentTypeAttributes = result.data[0].attribute;
                        const myArray = DataComponentService.fillAttributList(res.data?.componentAttributeList, componentTypeAttributes);
                        setComponentType(result.data[0]);
                        setComponentSelected(res.data);
                        setAttributeList(myArray);
                        setDataComponentFormDialogOpen(true);
                    }
                })()
            );
        } else if(rowData.componentTypeObjecttypeId || rowData.componentType?.objecttypeId) {
            const cTypeId = rowData.componentTypeObjecttypeId ? rowData.componentTypeObjecttypeId : rowData.componentType?.objecttypeId;
            await trackPromise(
                (async () => {
                    const result = await DataComponentService.getComponentTypeById(token, realm, cTypeId);
                    if(result && result.data && result.data.length > 0 && result.data[0].attribute) {
                        const componentTypeAttributes = result.data[0].attribute;
                        const myArray = DataComponentService.fillAttributList(rowData.componentAttributeList, componentTypeAttributes);
                        setComponentType(result.data[0]);
                        setComponentSelected(rowData);
                        setAttributeList(myArray);
                        setDataComponentFormDialogOpen(true);
                    }
                })()
            );
        }
    }

    const handleDeactivateClick = async (object, event) => {
        event.preventDefault();
        setIsLoading(true);
        const result = await DataComponentService.deactivateComponent(token, realm, object.guid);
        if(result.data?.error) {
            toast('Fehler beim Speichern: ' + result.data.error.message);
        } else {
            setIsLoading(true);
            setDataComponentFormDialogOpen(false);
            await reloadComponentList();
            setIsLoading(false);
        }
    }

    const handleActivateClick = async (object, event) => {
        event.preventDefault();
        setIsLoading(true);
        const result = await DataComponentService.activateComponent(token, realm, object.guid);
        if(result.data?.error) {
            toast('Fehler beim Speichern: ' + result.data.error.message);
        } else {
            setIsLoading(true);
            setDataComponentFormDialogOpen(false);
            await reloadComponentList();
            setIsLoading(false);
        }
    }

    const [title, setTitle] = useState('');

    // Autocomplete-Liegenschaftlist
    const [realestateobjectValue, setRealestateobjectValue] = useState(null);
    const [administrativeobjectValue, setAdministrativeobjectValue] = useState(null);
    const [realestateobjectSubValue, setRealestateobjectSubValue] = useState(null);
    const liegenschaftFlatList = [];
    const wirtschafteinheitFlatList = [];
    const [liegenschaftSubFlatList, setLiegenschaftSubFlatList] = useState([]);
    const lsfl = []
    if(dataObjects && dataObjects instanceof Array) {
        dataObjects.forEach(item => {
            convert2(item)
        });
    }

    function convert2(item) {
        const myItem = {};
        myItem.name = item.name;
        myItem.id = item.id;
        myItem.guid = item.guid;
        myItem.title = item.number + ' - ' + item.name;
        myItem.key = item.guid;
        myItem.type = 'realestateobject'
        liegenschaftFlatList.push(myItem);
    }

    if(administrativeObjects && administrativeObjects instanceof Array) {
        administrativeObjects.forEach(item => {
            convertAdministrativeObjects(item)
        });
    }

    function convertAdministrativeObjects(item) {
        const myItem = {};
        myItem.name = item.name;
        myItem.id = item.id;
        myItem.guid = item.guid;
        myItem.title = item.number + ' - ' + item.name;
        myItem.key = item.guid;
        myItem.type = 'administrativeobject'
        wirtschafteinheitFlatList.push(myItem);
    }


    function convert3(item) {
        const myItem = {};
        myItem.name = item.name;
        myItem.id = item.id;
        myItem.guid = item.guid;
        myItem.title = item.number + ' - ' + item.name;
        myItem.key = item.guid;
        lsfl.push(myItem);
    }

    const setRealestateobjectsValues = async(val) => {
        if (val) {
            setIsLoading(true);
            const objs = await DataobjectService.listrealestateobjectchildren(token, realm, val.guid);
            if(objs?.data && objs.data instanceof Array) {
                objs.data.forEach(item => {
                    convert3(item)
                });
            }

            setLiegenschaftSubFlatList(lsfl)
            setTitle(val.title);

            if(val.type === 'administrativeobject') {
                setAdministrativeobjectValue(val);
                setRealestateobjectValue(null);
                setRealestateobjectSubValues(val)
            } else {
                setRealestateobjectValue(val);
                setAdministrativeobjectValue(null);
                setRealestateobjectSubValues(val);
            }
        } else {
            setAdministrativeobjectValue(null);
            setRealestateobjectValue(null);
            setRealestateobjectSubValues(null)
            setTitle('')
        }
        setIsLoading(false)
    }

    const setRealestateobjectSubValues = async(val) => {
        setRealestateobjectSubValue(val)
        await setComponentTypeValue(value, val);
    }

    // Autocomplete-BauteiltypListe
    const [value, setValue] = React.useState(null);

    const treeFlatList = [];
    treeItemsState.forEach(item => {
        convert(item)
    });

    function convert(item) {
        const myItem = {};
        myItem.name = item.name;
        myItem.id = item.objecttype_id;
        myItem.code = item.code;
        myItem.title = item.code + ' - ' + item.name;
        myItem.cafmId = item.cafm_id;
        myItem.globalId = item.global_id;
        myItem.key = item.global_id;
        treeFlatList.push(myItem);
        item.children_objecttypes?.forEach(item2 => {
            convert(item2)
        });
    }


    const setComponentTypeValue = async(val, myRealestateobjectValue=null) => {
        setValue(val);

        if(!myRealestateobjectValue && realestateobjectValue) {
            myRealestateobjectValue = realestateobjectValue;
            setAdministrativeobjectValue(null);
        } else if(!myRealestateobjectValue && administrativeobjectValue) {
            myRealestateobjectValue = administrativeobjectValue;
            setRealestateobjectValue(null);
        }
        if(val) {
            await trackPromise(
                (async () => {
                    const [compResult, typeResult] = await Promise.all([
                        DataComponentService.getComponentsByComponentTypeCode(token, realm, val.code, myRealestateobjectValue?.guid),
                        DataComponentService.getComponentTypeByCode(token, realm, val.code),
                    ]);
                    console.dir(compResult);
                    setDatacomponents(compResult.data);
                    const attrs = typeResult?.data?.[0]?.attribute ?? [];
                    setComponentTypeAttributes(attrs);
                })()
            );
        } else {
            setComponentTypeAttributes([]);
            if(!val && myRealestateobjectValue?.type === 'administrativeobject') {
                setDatacomponents([]);
            } else if(!val && myRealestateobjectValue?.guid) {
                await trackPromise(
                    (async () => {
                        const result = await DataComponentService.getComponentsToRealestateobject(token, realm, myRealestateobjectValue?.guid);
                        setDatacomponents(result.data);
                    })()
                );
            }
        }
    }

    const changedComponenttypeValue = (val) => {
        setComponentTypeValue(val, realestateobjectSubValue);
    }

    const reloadComponentList = async () => {
        setIsLoading(true);
        let roGuid = realestateobjectSubValue ? realestateobjectSubValue.guid : realestateobjectValue?.guid;
        const result = await DataComponentService.getComponentsByComponentTypeCode(token, realm, value?.code, roGuid);
        setDatacomponents(result.data);
        setIsLoading(false);
    }

    const saveObject = async(formData, attributeData) => {
        await trackPromise(
            (async () => {
                const resp = await DataComponentService.saveComponent(token, realm, formData, attributeData);
                if(resp.data?.error) {
                    toast('Fehler beim Speichern: ' + resp.data.error.message);
                } else {
                    setIsLoading(true);
                    setDataComponentFormDialogOpen(false);
                    let roGuid = realestateobjectSubValue ? realestateobjectSubValue.guid : realestateobjectValue?.guid;
                    const result = await DataComponentService.getComponentsByComponentTypeCode(token, realm, value?.code, roGuid);
                    setDatacomponents(result.data);
                    setIsLoading(false);
                }
            })().catch((err) => {
                toast('Error: ' + err?.message);
                setIsLoading(false);
            })
        );
    }

    const addNew = () => {
        setComponentSelected([]);
        setDataComponentFormDialogOpen(true);
    }

    if(filtering) {
        hideDeactivatedColumn = false;
    }

    const getAttrValue = (rowData, attributeId) =>
        rowData.componentAttributeList?.find(
            a => a.mmsAttributeId?.toString() === attributeId?.toString()
        )?.value ?? '';

    const baseColumns = [
        { title: 'Bezeichnung', field: 'name' },
        { title: 'Nummer', field: 'number' },
        { title: 'Kennzeichen', field: 'label' },
        { title: 'Immobilienobjekt', field: 'realestateobjectName' },
        { title: 'deaktiviert', field: 'deactivated', lookup: { 0: 'nein', 1: 'ja' }, hidden: hideDeactivatedColumn },
    ];

    const dynamicColumns = componentTypeAttributes.map(attr => {
        if (attr.hasEnumerator) {
            const lookup = Object.fromEntries(
                (attr.enumeratorValues ?? []).map(e => [e.value, e.text])
            );
            return {
                title: attr.name,
                field: `attr_${attr.attribute_id}`,
                lookup,
                /*render: rowData => {
                    const val = getAttrValue(rowData, attr.attribute_id);
                    return (attr.enumeratorValues ?? []).find(e => e.value === val)?.text ?? val;
                },
                customFilterAndSearch: (term, rowData) => {
                    if (!term) return true;
                    return getAttrValue(rowData, attr.attribute_id) === term;
                },*/
            };
        }
        if (attr.data_type === 'Boolean') {
            return {
                title: attr.name,
                field: `attr_${attr.attribute_id}`,
                render: rowData => {
                    // const val = getAttrValue(rowData, attr.attribute_id);
                    const val = rowData['attr_' + attr.attribute_id];
                    if (val === null || val === undefined || val === '') return '';
                    if (val === true || val === 1 || val === '1' || val === 'true') return 'ja';
                    return 'nein';
                },
                filterComponent: ({ columnDef, onFilterChanged }) => (
                    <Select
                        variant="outlined"
                        value={columnDef.tableData?.filterValue ?? ''}
                        onChange={e => onFilterChanged(columnDef.tableData.id, e.target.value)}
                        displayEmpty
                        fullWidth
                        size="small"
                    >
                        <MenuItem value="">Alle</MenuItem>
                        <MenuItem value="true">ja</MenuItem>
                        <MenuItem value="false">nein</MenuItem>
                    </Select>
                ),
                customFilterAndSearch: (term, rowData) => {
                    if (!term) return true;
                    // const val = getAttrValue(rowData, attr.attribute_id);
                    const val = rowData['attr_' + attr.attribute_id];
                    if (val === null || val === undefined || val === '') return false;
                    const isTrue = val === true || val === 1 || val === '1' || val === 'true';
                    return term === 'true' ? isTrue : !isTrue;
                },
            };
        }
        return {
            title: attr.name,
            field: `attr_${attr.attribute_id}`,
           /* render: rowData => getAttrValue(rowData, attr.attribute_id),
            customFilterAndSearch: (term, rowData) =>
                String(getAttrValue(rowData, attr.attribute_id))
                    .toLowerCase()
                    .includes(term.toLowerCase()),*/
        };
    });

    const tableHeight = `calc(100vh - ${162 + 74}px)`; // filter-bar + toolbar + col-header + pagination + padding

    const canAdd = UserService.hasRole(['ADMIN_MAP', 'MAP_ADMIN', 'TWIN_MANDANT_ADMIN', 'TWIN_DATA_WRITER', 'TWIN_DATA_ADMIN']);

    const FilterToolbar = useCallback(
        (props) => (
            <>
                <MTableToolbar {...props} />
                <div style={{ position: 'absolute', right: '415px', top: '14px', display: 'flex', gap: '20px' }}>
                    <Button
                        variant="outlined"
                        size="small"
                        startIcon={<AddIcon />}
                        onClick={() => addNew()}
                        disabled={!canAdd}
                    >
                        Bauteil hinzufügen
                    </Button>
                    <Button
                        variant="outlined"
                        size="small"
                        startIcon={<FilterListIcon />}
                        onClick={() => setFiltering(f => !f)}
                    >
                        Spaltenfilter
                    </Button>
                </div>
            </>
        ),
        [setFiltering, canAdd]
    );

    return (
        <>
            <ToastContainer />
            <div className="page-filter-bar" style={{ background: 'rgb(240, 244, 248)' }}>
                <div className="page-filter-fields">
                    <ComponentTypeAutoComplete
                        flatList={liegenschaftFlatList}
                        setValue={setRealestateobjectsValues}
                        value={realestateobjectValue}
                        label="Liegenschaft"
                        width={260}
                    />
                    <ComponentTypeAutoComplete
                        flatList={wirtschafteinheitFlatList}
                        setValue={setRealestateobjectsValues}
                        value={administrativeobjectValue}
                        label="Wirtschaftseinheit"
                        width={260}
                    />
                    <ComponentTypeAutoComplete
                        flatList={liegenschaftSubFlatList}
                        setValue={setRealestateobjectSubValues}
                        value={realestateobjectSubValue}
                        label="Immobilienobjekt"
                        width={260}
                    />
                    <ComponentTypeAutoComplete
                        flatList={treeFlatList}
                        setValue={changedComponenttypeValue}
                        value={value}
                        label="Bauteiltyp"
                        width={260}
                    />
                </div>
            </div>
            <div style={{ padding: '12px', boxSizing: 'border-box', width: '100%' }}>
            <MaterialTable
                tableRef={tableRef}
                title={title}
                columns={[...baseColumns, ...dynamicColumns]}
                data={dataComponents}

                onRowClick={(event, rowData) => {
                    if(UserService.hasRole(['ADMIN_MAP', 'MAP_ADMIN', 'TWIN_MANDANT_ADMIN', 'TWIN_DATA_WRITER', 'TWIN_DATA_ADMIN'])) {
                        handleEditClick(event, rowData);
                    }
                }}
                options={{
                    headerStyle: header,
                    rowStyle: rowData => ({
                        backgroundColor: (rowData.deactivated) ? '#EEE' : '#FFF',
                        display: (hideDeactivatedColumn && rowData.deactivated) ? 'none': ''
                    }),
                    pageSize: 10,
                    pageSizeOptions: [10, 20, 50, 100],
                    actionsColumnIndex: -1,
                    filtering,
                    exportButton: true,
                    exportAllData: true,
                    maxBodyHeight: tableHeight,
                    minBodyHeight: tableHeight,
                }}
                components={{
                    Container: props => <Paper {...props} style={{ ...props.style, position: 'relative' }} />,
                    Toolbar: FilterToolbar,
                }}
                actions={[
                    {
                        icon: 'edit',
                        tooltip: 'Editieren',
                        onClick: (event, rowData) => handleEditClick(event, rowData),
                        disabled: !canAdd
                    },
                    rowData => ({
                        icon:  rowData.deactivated ? 'taskalt' : 'cancel',
                        tooltip: rowData.deactivated ? 'Aktivieren': 'Deaktivieren',
                        onClick: rowData.deactivated ? (event, rowData) => handleActivateClick(rowData, event) :(event, rowData) => handleDeactivateClick(rowData, event),
                        disabled: !canAdd
                    }),
                ]}
                isLoading={isLoading}
                localization={{
                    pagination: {
                        labelDisplayedRows: '{from}-{to} von {count}',
                        labelRowsSelect: 'Zeilen',
                        labelRowsPerPage: 'Zeilen pro Seite'
                    },
                    toolbar: {
                        nRowsSelected: '{0} Zeile(n) ausgewählt',
                        searchTooltip: 'Suchen',
                        searchPlaceholder: 'Suchbegriff eingeben'
                    },
                    header: {
                        actions: ''
                    },
                    body: {
                        emptyDataSourceMessage: 'Keine Einträge gefunden',
                        filterRow: {
                            filterTooltip: 'Filter'
                        }
                    }
                }}

            />
            </div>
            <ComponentFormView
                dataObjectSelected={dataObjectSelected}
                setDataComponentFormDialogOpen={setDataComponentFormDialogOpen}
                DataComponentFormDialogOpen={DataComponentFormDialogOpen}
                componentSelected={componentSelected}
                componentType={componentType}
                attributeList={attributeList}
                setAttributeList={setAttributeList}
                realestateobjectGuid={realestateobjectGuid}
                handleActivateClick={handleActivateClick}
                handleDeactivateClick={handleDeactivateClick}
                saveObject={saveObject}
                reloadComponentList={reloadComponentList}
            />

        </>
    )
}

export default DatacomponentTableView;
